

import { getMultiSectionDigitalClockSectionUtilityClass } from "@mui/x-date-pickers/MultiSectionDigitalClock/multiSectionDigitalClockSectionClasses";
import React from "react";


// // Constantes physiques
// const epsilon_g = 0.95; // Émissivité de la boule noire
// const sigma = 5.67e-8; // Constante de Stefan-Boltzmann (W/m²K⁴)



function newtonRaphson(f, x0, tol = 1e-6, maxIter = 1000, alpha=1e-1) {
  let x = x0; // Point de départ
  for (let i = 0; i < maxIter; i++) {
    const fx = f(x);
    const dfx = (f(x + 1e-6) - fx) / 1e-6; // Approximation numérique de la dérivée
    if (Math.abs(dfx) < tol) {
      throw new Error("La dérivée est trop proche de zéro");
    }
    console.log("x", x)
    console.log("fx", fx)
    console.log("dfx", dfx)

    // const nextX = x - fx / dfx; // Formule de Newton-Raphson
    const nextX = x - alpha * fx / dfx; // Formule de Newton-Raphson
    // if (Math.abs(nextX - x) < tol && Math.abs(fx) < tol) {
    if (Math.abs(nextX - x) < tol) {
      console.log("Solution trouvée", nextX)
      return nextX; // Solution trouvée
    }
    x = nextX; // Mise à jour

  }
  throw new Error("Newton-Raphson n'a pas convergé");
}






function calculateWBGT({ Ta, RH, Tg, D, Va }) {
  




  // Calculer WBGT_stull
  const calculate_tnw_stull = (Ta_val, Tg_val, RH_val) => {
    const t_nw_stull =
      Ta_val * Math.atan(0.151977 * Math.sqrt(RH_val + 8.313659)) +
      Math.atan(Ta_val + RH_val) -
      Math.atan(RH_val - 1.676331) +
      0.00391838 * Math.pow(RH_val, 1.5) * Math.atan(0.023101 * RH_val) -
      4.686035;

    const WBGT_stull = (0.7 * t_nw_stull + 0.2 * Tg_val + 0.1 * Ta_val).toFixed(1);
    return { WBGT_stull, t_nw_stull };
  };

  const { WBGT_stull, t_nw_stull } = calculate_tnw_stull(Ta, Tg, RH);






  
  // Fonction de pression de vapeur saturée
  const p_as = (T) => 0.6108 * Math.exp((17.269 * T) / (T + 237.3)); // en kPa
  // Tr = Math.pow( Math.pow(Tg + 273, 4) + (1.1e8 * Math.pow(Va, 0.6)) / (epsilon_g * Math.pow(D / 100, 0.4)) * (Tg - Ta) ,1/4) - 273
  
  // const calculate_Tr = (Tg, Ta, Va, D, epsilon_g) => {
  //   const term1 = Math.pow(Tg + 273, 4);
  //   const term2 = (1.1e8 * Math.pow(Va, 0.6)) / (epsilon_g * Math.pow(D / 100, 0.4)) * (Tg - Ta);
  //   const Tr = Math.pow(term1 + term2, 1/4) - 273; // Conversion en °C
  //   return Tr;
  // };
  
  // Calculer WBGT avec t_nw
  function calculate_WBGT_ISO(Ta, RH, Tg, D, Va) {
    // // Constantes physiques
    const epsilon_g = 0.95; // Émissivité de la boule noire

    // // Équation 1 : Température radiante (Tr)
    // function t_r_equation(Tr) {
    //   return (
    //     Math.pow(Tg + 273, 4) +
    //     (1.1e8 * Math.pow(Va, 0.6)) / (epsilon_g * Math.pow(D / 100, 0.4)) *
    //       (Tg - Ta) -
    //     Math.pow(Tr + 273, 4)
    //   );
    // }

    // Résolution de Tr avec Newton-Raphson
    // const Tr = newtonRaphson(t_r_equation, Tg);
    const Tr =
    Math.pow(
        Math.pow(Tg + 273, 4) +
        (1.1579e8 / 0.95 / Math.pow(D / 100, 0.4)) * Math.pow(Va, 0.6) * (Tg - Ta),
        0.25
    ) - 273;
    console.log("Tr", Tr)

    // Équation 2 : Conservation d'énergie pour t_nw
    function t_nw_equation(t_nw) {
      return (
        4.18 * Math.pow(Va, 0.444) * (Ta - t_nw) +
        1e-8 * (Math.pow(Tr + 273, 4) - Math.pow(t_nw + 273, 4)) -
        77.1 * Math.pow(Va, 0.421) * (p_as(t_nw) - (RH / 100) * p_as(Ta))
      );
    }



    // Calcul de t_nw avec Newton-Raphson
    const t_nw = newtonRaphson(t_nw_equation, 20); // Point de départ amélioré
    console.log("t_nw", t_nw)

    // Calcul du WBGT final
    const WBGT = 0.7 * t_nw + 0.2 * Tg + 0.1 * Ta;

    return WBGT.toFixed(1);
  }

  const WBGT = calculate_WBGT_ISO(Ta, RH, Tg, D, Va);

  // Retour des résultats
  return {
    WBGT,
    WBGT_stull,
  };
}

export default calculateWBGT;
